// extracted by mini-css-extract-plugin
export default {"gridColumnTemplate":"HiddenDiffPatch-module__gridColumnTemplate--gSfuk"};